import type React from 'react';
import type { VisualFractionPart } from '../types';

/** Returns the interactive ARIA + event props for a clickable part. */
export function getInteractiveProps(
  part: VisualFractionPart,
  onPartClick: (index: number) => void,
) {
  if (!part.isInteractiveSlot) return {};

  return {
    onClick: () => onPartClick(part.index),
    role: 'button' as const,
    'aria-pressed': part.isSelected,
    'aria-label': getPartAriaLabel(part),
    tabIndex: 0,
    onKeyDown: (event: React.KeyboardEvent<HTMLElement | SVGElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onPartClick(part.index);
      }
    },
  };
}

function getPartAriaLabel(part: VisualFractionPart): string {
  return part.groupIndex === null
    ? `Part ${part.index + 1}, empty`
    : `Part ${part.index + 1}, group ${part.groupIndex + 1}`;
}
